export const UCGJEE = ['U', 'C', 'G', 'J', 'EE']
